var _path, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _path8, _line3, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _line4, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _line5, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactNormalInchisPrinProtectiaElectromagneticaLaSupracurent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 31L37 14.8024L37 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 30H47.5H59",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24.9023L37 49",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 31L37 14.8024L37 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24.9023L37 49",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 40,
    x2: 36,
    y2: 40,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 40,
    x2: 14,
    y2: 40,
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.24627e-07 47C3.86599 47 7 44.0899 7 40.5C7 36.9101 3.86599 34 -1.24627e-07 34",
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 40,
    x2: 17,
    y2: 40,
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.24627e-07 47C3.86599 47 7 44.0899 7 40.5C7 36.9101 3.86599 34 -1.24627e-07 34",
    stroke: "black",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37 31L37 14.8024L37 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36 30H47.5H59",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24.9023L37 49",
    stroke: "black",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37 31L37 14.8024L37 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24.9023L37 49",
    stroke: "black",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 40,
    x2: 36,
    y2: 40,
    stroke: "black",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37 31L37 14.8024L37 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36 30H47.5H59",
    stroke: "black",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24.9023L37 49",
    stroke: "black",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37 31L37 14.8024L37 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24.9023L37 49",
    stroke: "black",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 40,
    x2: 28,
    y2: 40,
    stroke: "black",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40L42 40",
    stroke: "black",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37 31L37 14.8024L37 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36 30H47.5H59",
    stroke: "black",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24.9023L37 49",
    stroke: "black",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37 31L37 14.8024L37 3.25567e-07",
    stroke: "black",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24.9023L37 49",
    stroke: "black",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1 35L1 16.5",
    stroke: "black",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1 64.5L1 46",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNormalInchisPrinProtectiaElectromagneticaLaSupracurent);
export default __webpack_public_path__ + "static/media/contact_normal_inchis_prin_protectia_electromagnetica_la_supracurent.f2abef971c778e0e321866feda08c00f.svg";
export { ForwardRef as ReactComponent };